var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.44575C0 1.46519 0.797222 0.667969 1.77778 0.667969H8.88889C9.86944 0.667969 10.6667 1.46519 10.6667 2.44575V9.55686C10.6667 10.5374 9.86944 11.3346 8.88889 11.3346H1.77778C0.797222 11.3346 0 10.5374 0 9.55686V2.44575ZM15.5306 1.66241C15.8194 1.81797 16 2.11797 16 2.44575V9.55686C16 9.88463 15.8194 10.1846 15.5306 10.3402C15.2417 10.4957 14.8917 10.4791 14.6167 10.2957L11.95 8.51797L11.5556 8.25408V7.77908V4.22352V3.74852L11.95 3.48464L14.6167 1.70686C14.8889 1.5263 15.2389 1.50686 15.5306 1.66241Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.43040c39bedac12d542cb296cd88fdf3.svg";
export { ForwardRef as ReactComponent };